import { defineStore } from 'pinia'

export const useLoadingStore = defineStore('Loading', {
    state: () => ({
        openRequests: 0,
    }),
    getters: {
        loading: (state) => {
            return state.openRequests > 0;
        }
    },
    actions: {
        openRequest() {            
            this.openRequests++;
        },
        closeRequest() {            
            if (this.openRequests > 0){                
                this.openRequests--;
            }                
        },
    },
})